export const variationTags = [
  { value: 'actionable', label: 'Actionable' },
  { value: 'storytelling', label: 'Storytelling' },
  { value: 'thought-provoking', label: 'Thought-provoking' },
  { value: 'promotional', label: 'Promotional' },
];

export const formatTags = [
  { value: 'listicles', label: 'Listicles' },
  { value: 'concise', label: 'Concise' },
  { value: 'long-form', label: 'Long-form' },
  { value: 'emoji-free', label: 'Emoji-free' },
  { value: 'numbers', label: 'Numbers' },
  { value: 'one sentence long, 280 characters max', label: 'One-liner' },
];

export const toneTags = [
  { value: 'assertive', label: 'Assertive' },
  { value: 'enthusiastic', label: 'Enthusiastic' },
  { value: 'irreverent', label: 'Irreverent' },
  { value: 'friendly', label: 'Friendly' },
  { value: 'humorous', label: 'Humorous' },
  { value: 'ironic', label: 'Ironic' },
  { value: 'formal', label: 'Formal' },
  { value: 'serious', label: 'Serious' },
  { value: 'humble', label: 'Humble' },
  { value: 'persuasive', label: 'Persuasive' },
  { value: 'critical', label: 'Critical' },
  { value: 'straightforward', label: 'Straightforward' },
  { value: 'sarcastic', label: 'Sarcastic' },
  { value: 'optimistic', label: 'Optimistic' },
  { value: 'pessimistic', label: 'Pessimistic' },
  { value: 'celebratory', label: 'Celebratory' },
  { value: 'compassionate', label: 'Compassionate' },
];

export const angleTags = [
  {
    value: 'a contrarian post with a unique take about a topic',
    label: 'Contrarian',
  },
  {
    value:
      'an inspirational post which motivates and inspires people about the topic',
    label: 'Inspirational',
  },
  {
    value:
      'a story-based post which mentions real or invented succession of events related to the topic',
    label: 'Story',
  },
  {
    value: `a post based on one of the author's real-life experiences`,
    label: 'Life Experience',
  },
  {
    value:
      'a post describing 3 to 5 easy-steps to accomplish something related to the topic',
    label: 'Easy Steps',
  },
  {
    value:
      'a post comparing 2 approaches or methods, encouraging the reader to make a choice between both',
    label: 'Comparison',
  },
  {
    value: `a post explaining why the reader is "doing it wrong", with a typical "if you're doing X, you're doing it wrong, here's why" structure`,
    label: 'You’re Doing It Wrong',
  },
  {
    value: `a post sharing the author's secret tactic or tool or approach about the topic`,
    label: 'My Secret',
  },
  {
    value: `a post sharing the author's uncommon tactics related to the topic`,
    label: 'Tactical',
  },
  {
    value:
      'a post where the author explains how he thought he knew something about the topic but was actually wrong',
    label: 'I Thought I Knew',
  },
  {
    value: `a promotional post that drives conversion for the user's business`,
    label: 'Promotional',
  },
];

export const structureTags = [
  {
    value: 'Attention - Interest - Desire - Action',
    label: 'AIDA',
    hoverText: 'Attention - Interest - Desire - Action',
  },
  {
    value: 'Problem - Agitation - Solution',
    label: 'PAS',
    hoverText: 'Problem - Agitation - Solution',
  },
  {
    value: 'Before - After - Bridge',
    label: 'BAB',
    hoverText: 'Before - After - Bridge',
  },
  {
    value: 'Praise - Picture - Push',
    label: 'PPP',
    hoverText: 'Praise - Picture - Push',
  },
];

export interface tags {
  value: string;
  label: string;
  hoverText?: string;
}
